import React from "react";
import { FormattedMessage } from "react-intl";
import { Link, useSearchParams } from "react-router-dom";
import { categories } from "../../utils/siteValues";
import styles from "./CategoryChips.module.scss";

const CategoryChips: React.FC = () => {
  const [searchParams] = useSearchParams();
  const activeCategory = searchParams.get("categories") || "";

  return (
    <div className={styles.categoryChips}>
      <div className={styles.chipsContainer}>
        {categories.map((category: string) => {
          const isActive = activeCategory === category;
          const newParams = new URLSearchParams(searchParams);
          if (isActive) {
            newParams.delete("categories");
          } else {
            newParams.set("categories", category);
          }

          return (
            <Link
              key={category}
              to={`/patterns?${newParams.toString()}`}
              className={`${styles.chip} ${isActive ? styles.active : ""}`}
            >
              <FormattedMessage
                id={`categories.categories.${category}`}
                defaultMessage={category}
              />
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryChips;
